import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'

export const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/admin',
    redirect: '/map',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('@/views/mapView/index.vue'),
    meta: { title: '地图监控' },
  },
  {
    path: '/device',
    name: 'device',
    component: () => import('@/views/deviceView/index.vue'),
    meta: { title: '设备总览' },
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/historyView/index.vue'),
    meta: { title: '连接记录' },
  },
 
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
